import { render, staticRenderFns } from "./firstClass.vue?vue&type=template&id=6a4dcbf0&scoped=true&"
import script from "./firstClass.vue?vue&type=script&lang=js&"
export * from "./firstClass.vue?vue&type=script&lang=js&"
import style0 from "./firstClass.vue?vue&type=style&index=0&id=6a4dcbf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4dcbf0",
  null
  
)

export default component.exports